import type { CourseSummaryInstructorBasicInfo } from './courseSummaryInstructorBasicInfo';
import type { CourseSummaryInstructorSocial } from './courseSummaryInstructorSocial';

/**
 * 강사 정보
 */
export type CourseSummaryInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: CourseSummaryInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: CourseSummaryInstructorSocial;
};
